import React, { useState } from 'react';
import Cookies from 'js-cookie';

import './style.scss';
import Button from '../../../components/Button';

const Intro = () => {
  const experienceIntroShown = Cookies.get('of-experience-intro-shown') || false;
  const [hidden, setHidden] = useState(experienceIntroShown === 'true');

  const onHide = () => {
    Cookies.set('of-experience-intro-shown', 'true');
    setHidden(true);
  };

  if (hidden) {
    return null;
  }

  return (
    <div className="Experience360Intro">
      <div className="Experience360Intro__content">
        <h1>Welkom in de Oranje Fonds Straat!</h1>
        <p>Beweeg de straat naar links of rechts met je muis of vinger en ontdek 20 persoonlijke verhalen uit 20 jaar ertoe doen.</p>
        <Button primary withIcon buttonIcon onClick={onHide}>Verken de straat</Button>
        <Button className="Experience360Intro__close" withIcon icon="cross" variant="icon-variant-0" onClick={onHide} />
      </div>
    </div>
  );
};

export default Intro;
